import styles from '../../styles/sass/layout/Mission.module.scss'

export default function Mission() {
    return (
        <div className={styles.mission}>
            <h2 className={styles.missionTitle}>
                Támogatlak, hogy otthonra találhass önmagadban.
            </h2>
            <div className={styles.missionDescriptionContainer}>
                <h2 className={styles.missionDescription}>
                    Jelen lenni önmagunkban talán az egyik legnagyobb kihívás. Az ide vezető út gyakran bizonytalan, tele kérdésekkel, elakadásokkal és nehézségekkel – de sosem késő elindulni rajta. A közös munka során abban támogatlak, hogy mélyebben megértsd önmagad, felfedezd belső erőforrásaidat, és egyre nagyobb belső szabadsággal, önazonosabban lehess jelen a saját életedben.
                </h2>
            </div>
        </div>
    );

}